import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthHttpService } from './';


export class GuestGuardService implements CanActivate {

	private allowedChildRoutes: string[] = [
		'candidate/profile',
		'client/billing'
	];

	constructor(private sHttp: AuthHttpService) { }

	public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		if (!route.firstChild) {
			window.location.assign(process.env.LANDING_PAGES_URL);
			return false;
		}

		if (this.allowedChildRoutes.indexOf(route.firstChild.routeConfig.path) === -1) {
			window.location.assign(process.env.LANDING_PAGES_URL);
			return false;
		}

		this.sHttp.setAuthToken(route.params.token);

		return true;
	}
static ctorParameters() { return [ { type: AuthHttpService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/guest/services/guest-guard.service.ts